import React from 'react';

import ArchiveWidget from '../ArchiveWidget/ArchiveWidget';


const title = {
  segment: 'Segment Archive',
  anchor: 'Anchor Archive',
  date: 'Full Archives',
  vintage: 'Vintage Naked News',
  all: 'Full Archives',
  search: 'Search Archives',
};

class ArchivesList extends React.Component {

  render() {
    const { arhives, typeOfListing, listingId, listingTitle, slug, searchFullText } = this.props;

    return (
      <div className="content" id="arhive_index_view">
        <div className="container">
          <h1 className="h2">{title[typeOfListing]}<small>{listingTitle}</small></h1>
          <div className="row-r archives-content">
            {
              arhives.map((arhive, index) => (
                <ArchiveWidget
                  key={index}
                  arhive={arhive}
                  listingId={listingId}
                  searchFullText={searchFullText}
                  slug={slug}
                  typeOfListing={typeOfListing}
                />
              ))
            }
          </div>
        </div>
      </div>
    );
  }
}

export default ArchivesList;
